export default __webpack_public_path__ + "02a7f178ac14dd32d21f42529e90abc7.png";